"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrawerContext = void 0;
const react_1 = require("react");
exports.DrawerContext = (0, react_1.createContext)({});
//# sourceMappingURL=drawer-context.js.map